import { render, staticRenderFns } from "./SemiCircleChart.vue?vue&type=template&id=7050319f&"
import script from "./SemiCircleChart.vue?vue&type=script&lang=js&"
export * from "./SemiCircleChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports